import { page, shows, type FeatureRoutes } from "@/app/feature";

export const routes: FeatureRoutes = {
  shell: [{ path: "boosters", lazy: page(() => import("./BoostersPage")), handle: shows("boosters") }],
};
